module.exports = __webpack_public_path__ + "res/ic_menu_rewards_won.4519b8cf1eebf8fece5ed07735bb6a93.png";